import { Button, Group, Select } from '@mantine/core';
import CustomSearch from '../../../../../../ui/search/customSearch';
import { noticeTypeOptions, solutionOptions } from '../../../../../../../shared/constants/commonCode';
import { useSearchFilters } from '../../../../../../../shared/hook/useSearchFilter';
import { useCustomSearch } from '../../../../../../../shared/hook/useCustomSearch';
import { useNavigate } from 'react-router-dom';

export default function PopupToolbar() {
  const navigate = useNavigate();
  const initSearchType = 'title';
  const { searchType, solutionFilter, noticeTypeFilter, updateFilters } = useSearchFilters({
    initType: initSearchType,
  });

  //  검색 키워드 훅
  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: initSearchType,
  });

  const onChangeSolutionFilter = (option: { value: string; label: string }) => {
    if (option) {
      updateFilters({
        page: '1',
        solution: option.value,
      });
    }
  };

  const onChangeNoticeTypeFilter = (option: { value: string; label: string }) => {
    if (option) {
      updateFilters({
        page: '1',
        noticeType: option.value,
      });
    }
  };

  return (
    <Group justify="space-between" mb={20} align="flex-end">
      <Group gap="sm" align="flex-end">
        <Select
          w={140}
          label="솔루션"
          data={[{ label: '전체', value: 'all' }, ...solutionOptions]}
          value={solutionFilter}
          onChange={(_value, option) => onChangeSolutionFilter(option)}
        />
        <Select
          w={140}
          label="팝업 유형"
          data={[{ label: '전체', value: 'all' }, ...noticeTypeOptions]}
          value={noticeTypeFilter}
          onChange={(_value, option) => onChangeNoticeTypeFilter(option)}
        />
        <CustomSearch
          resetSearch={resetWord}
          resetSearchInput={resetSearchInput}
          searchType={searchType}
          setSearchType={handleSearchType}
          inputRef={inputRef}
          handleSearch={handleSearch}
          searchOptions={[{ value: 'title', label: '제목' }]}
        />
      </Group>
      <Button variant="filled" color="secondary.5" onClick={() => navigate('/admin/edgecross/notice/popup/register')}>
        등록
      </Button>
    </Group>
  );
}
